import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import Classes, { Account, Deposit } from "model";
import DepositHistorySearch from "./classes/DepositHistorySearch";

import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import DepositHistorySearchAccordion from './components/DepositHistorySearchAccordion';
import DepositHistorySearchCriteria from './components/DepositHistorySearchCriteria';
import DepositHistoryView from "./components/DepositHistoryView";
import MobileDepositHistoryView from "./components/MobileDepositHIstoryView";

import "./styles.css";
import "./mobile.css";


export default function DepositHistoryPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    //const accountID = useParams().accountID ?? "0";
    const accountID = useParams().accountID ?? Account.getDefaultBrandedAccountByType("checking").id;

    const data = { ...getDefaultPageData(accountID), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onSearchUpdate: prop => value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "ui", "showCustomDateRange" ], prop === "date" ? value === "custom" : state.ui.showCustomDateRange)
                .update([ "data", "search", prop ], value)
                .submit(setState);
        },

        onShowAmountRange: value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "search", "amount" ], undefined)
                .update([ "data", "search", "minAmount" ], undefined)
                .update([ "data", "search", "maxAmount" ], undefined)
                .update([ "ui", "showAmountRange" ], value === "Amount Range")
                .submit(setState);
        },

        onSearchReset: evt => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "deposits" ], Deposit.getSortedDeposits())
                .update([ "data", "search" ], state.data.search.reset())
                .update([ "ui", "showCriteria" ], false)
                .update([ "ui", "isSearching" ], false)
                .update([ "ui", "showAmountRange" ], false)
                .submit(setState);
        },

        onSearchSubmit: evt => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "deposits" ], state.data.search.filter())
                .update([ "data", "submittedSearch" ], DepositHistorySearch.init(state.data.search.record))
                .update([ "ui", "showCriteria" ], true)
                .update([ "ui", "isSearching" ], true)
                .update([ "ui", "showSearchAccordion" ], false)
                .submit(setState);
        },

        onAccordionToggle: value => {
            BCMSStateManagerCRUD.init(state)    
                .update([ "ui", "showSearchAccordion" ], value)
                .submit(setState);
        },

        onItemClick: (key, prop, value) => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", key, "showChecks" ], prop === "accordionActive" && !value ? false : state.ui[key].showChecks)
            .update([ "ui", key, prop ], value)
            .submit(setState);
        }
    });

    return (
        <PageContainer className="deposit-history-page" state={ { data, ui } } controller={ controller }>
            <DepositHistoryContent />
        </PageContainer>
    );
}

export const getDefaultPageData = id => ({
    account: Account.initByType(id),
    search: DepositHistorySearch.init(),
    submittedSearch: DepositHistorySearch.init(),
    deposits: Deposit.getSortedDeposits()
});
export const getDefaultPageUI = () => ({
    showSearchAccordion: false,
    showCriteria: false,
    showCustomDateRange: false,
    showAmountRange: false,

    isSearching: false
});

function DepositHistoryContent(props) {
    return (
        <PageContentView>
            <CenterContentContainer>
                <div className="container-section">
                    <ContentHeaderView text="Deposit History" />
                </div>

                <DepositHistorySearchAccordion />
                <DepositHistorySearchCriteria />

                <DepositHistoryView />
                <MobileDepositHistoryView />
            </CenterContentContainer>
        </PageContentView>
    )
}